import { ProjectMember } from './onboarding';
import { IAttachment } from './attachments';

export interface IProject {
    id: string;
    projectName: string;
    status: string;
    date: string | null;
    priority: number;
    description: string;
    attachments?: IAttachment[];
}

export interface IProjectQueue {
    pending: number;
    inReview: number;
    inProgress: number;
}

export interface IProjectActivity {
    date: string;
    workItemsSolved: number;
    tasksCompleted: number;
    tasksDelegated: number;
    workItemsReviewed: number;
}

export interface IProjectContributor {
    id: string;
    name: string;
    country: string;
    status: string;
    lastStatusUpdated: string | null;
    lastWork: string;
    lastEngagement: string;
    reservedWorks: number;
    worksInReview: number;
    hourlyRate: string;
    skills: string[];
}

export enum BudgetCategory {
    CORE_TEAM = 'CORE_TEAM',
    TECH_LEAD = 'TECH_LEAD',
    QA_CONTRIBUTOR = 'QA_CONTRIBUTOR',
    CONTRIBUTOR = 'CONTRIBUTOR',
    PROJECT_MANAGER = 'PROJECT_MANAGER',
    UI_UX = 'UI_UX',
    THIRD_PARTY = 'THIRD_PARTY',
    LLM = 'LLM'
}

export interface IProjectBudgetBreakdownReview {
    name: BudgetCategory;
    amount: number;
    hours: number;
}
export interface IProjectBudgetReview {
    date: string;
    budget: IProjectBudgetBreakdownReview[];
}

export interface IProjectDelayedTask {
    id: string;
    createdAt: string;
    updatedAt: string;
    taskName?: string;
    skills: string[];
    status: string;
    billableTime: number;
    link: string | null;
}

export interface IProjectData {
    id: string;
    queue: IProjectQueue;
    activities: IProjectActivity[];
    contributors: IProjectContributor[];
    budgetReviews: IProjectBudgetReview[];
    delayedTasks: IProjectDelayedTask[];
}

export interface ITasksQueue {
    reserved: number;
    pending: number;
    available: number;
    inReview: number;
    delayed: number;
}

export interface IProjectsList {
    id: string;
    projectName: string;
    averageRating: number;
    priority: string;
    status: string;
    netWorkingTime: string;
    activeContributors: number;
    delegatedTasks: number;
    completedTasks: number;
    totalBudget: number;
    totalExpenese: number;
    lastWorkDate: string;
    lastWorkTime: string;
    tasksQueue: ITasksQueue;
}

export interface TeamMember {
    id: string;
    name: string;
    email: string;
    role: 'Member' | 'Admin' | 'Remove';
}

export interface ProjectSkill {
    id: string;
    name: string;
}

export interface User {
    id: string;
    name: string;
    email: string;
}

export enum ThirdPartyProvider {
    AWS = 1
}

export interface IThirdPartyExpense {
    id: number;
    accountId: string;
    provider: ThirdPartyProvider;
}

export interface UpdateProjectRequest {
    projectId: number;
    name?: string;
    description?: string;
    skills?: string[];
    members?: ProjectMember[];
    priority?: number;
    attachmentList?: number[];
}
